import { render, staticRenderFns } from "./GridProfissionalLegado.vue?vue&type=template&id=682f440a"
import script from "./GridProfissionalLegado.vue?vue&type=script&lang=js"
export * from "./GridProfissionalLegado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports